"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/bee-transition@0.2.5_dcdmdzjel7sn5rgv2xzbvbfoxq/node_modules/bee-transition/build/util/capitalize.js
// module id = 120
// module chunks = 0